import * as ACTIONS from '../actions/constants';


const initialState = {
  favourites: undefined,
  recent: undefined,
  recommended: []
};

function activity(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.UPDATE_FAVOURITES:
      return { ...state, favourites: action.payload };
    case ACTIONS.UPDATE_RECENT:
      return { ...state, recent: action.payload };
    case ACTIONS.UPDATE_RECOMMENDED:
      return initialState;
    case ACTIONS.USER_LOG_OUT:
      return initialState;
    default:
      return state;
  }
}

export default activity;



// WEBPACK FOOTER //
// ./src/reducers/activity.js